<template>
  <div id="vessel-view-data">
    <vessel-form
      mode="view"
      :itemId="itemId"
      :lastSearchCondition="lastSearchCondition"
    >
    </vessel-form>
  </div>
</template>

<script>

import VesselForm from "./VesselForm";

export default {
  components: {
    VesselForm,
  },
  data() {
    return {
      itemId: this.$route.params.itemId,
      lastSearchCondition: this.$route.params.lastSearchCondition
    }
  },
  created() {
  },
  computed: {
  },
  methods: {
  }
}
</script>

<style lang="scss" scoped>
</style>
